<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col cols="12">
				<b-alert
					v-if="notAllowedError"
					:show="dismissCountDown"
					dismissible
					variant="warning"
					@dismissed="dismissCountDown=0"
					@dismiss-count-down="countDownChanged"
				>
					<p>{{ deleteRefErrorMessage }}</p>
				</b-alert>
				<b-card>
					<div slot="header" class="d-flex justify-content-between custom-card-header">
						<h5 class="card-header-title">{{$t('reference.title')}}</h5>
						<div class="searchInCard">
							<b-input-group size="sm">
								<b-form-input v-model="filter" size="sm" :placeholder="$t('contragent.filter')"/>
								<b-input-group-append>
									<b-button :disabled="!filter" @click="filter = ''">{{$t('contragent.clear')}}
									</b-button>
								</b-input-group-append>
							</b-input-group>
						</div>
						<div class="card-header-actions">
							<b-link @click="showRefModal({})"
									size="sm"
									variant="primary"
									v-if="$can('create/edit', 'parent reference')"
							>
								<i class="fa fa-plus-circle" style="font-size: 1.2em; color: #53575B"></i>
							</b-link>
						</div>
					</div>
					<b-table class="generalTableClass" :busy="isBusy" hover="hover" striped="striped"
							 bordered="bordered" small="small"
							 :filter="filter"
							 fixed="fixed" responsive="sm" :items="getReferences" :fields="computedFields"
							 :current-page="currentPage" :per-page="perPage" show-empty>

						<!-- EMPTY SLOT FOR TABLE -->
						<template slot="empty" slot-scope="scope">
							<h4>{{ $t('empty') }}</h4>
						</template>
						<!-- EMPTY SLOT FOR TABLE -->

						<template slot="name" slot-scope="data" class="col-md-8">
							<template v-if="$can('create/edit', 'parent reference')">
								<p v-bind:key="data.item.id + 'name'"
								   v-if="focusedData.id != data.item.id"
								   @dblclick="changeFocused(data)"
								   v-b-tooltip.hover
								   :title="$t('actions.update')">{{ data.value }}</p>

								<b-form-input autofocus ref="refNameRef"
											  @focusout.native="inputUnfocused(data, data.value)"
											  @keydown.enter="inputUnfocused(data, data.value)"
											  v-bind:key="data.item.id + 'name'" v-model="data.value"
											  v-if="focusedData.id === data.item.id && focusedData.key === data.field.key"></b-form-input>
							</template>
							<template v-else>
								<p
									v-bind:key="data.item.id + 'name'"
								>
									{{ data.value }}
								</p>
							</template>

						</template>
						<template slot="childRefs" slot-scope="data" class="col-md-8">
							<b-link :key="data.item.id" @click="childRefsLink(data.item.code)">{{$t('sub-reference.title')}}</b-link>
						</template>
						<template slot="actions" slot-scope="data" class="col-md-8">
							<b-link :key="data.item.id + 'delete'"
									@click="onOpen(data.item.id)"
									:id="'popOverDelete'+data.item.id"
							>
								<i class="fa fa-trash"></i>
							</b-link>
							<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
							<b-popover
								:key="data.item.id + 'popover'"
								:target="'popOverDelete'+data.item.id"
								placement="auto"
								container="myContainer"
								:ref="'popover'+data.item.id"
								class="refDeleteConfirm"
							>
								<template slot="title">
									<b-button @click="onClose(data.item.id)" class="close" aria-label="Close"
											  style="margin-left: 5px">
										<span class="d-inline-block" aria-hidden="true">&times;</span>
									</b-button>
									{{$t('actions.deletetitle')}}?
								</template>

								<div>
									<div class="row mt-1">
										<div class="col-6">
											<b-button variant="outline-danger" size="sm" block
													  @click="onClose(data.item.id)">{{$t('actions.no')}}
											</b-button>
										</div>
										<div class="col-6">
											<b-button variant="outline-success" size="sm" block
													  @click="onOk(data.item.id)">{{$t('actions.yes')}}
											</b-button>
										</div>
									</div>
								</div>
							</b-popover>
							<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
						</template>
					</b-table>
					<nav>
						<b-pagination :total-rows="getReferences.length" :per-page="perPage" v-model="currentPage"
									  :prev-text="$t('pagination.prev')"
									  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
					</nav>
				</b-card>
			</b-col>

			<!-- MODAL FOR ADDING AND EDITING REFERENCE -->
			<b-modal body-class="refModal" ref="updateRefModal" hide-footer ok-title="Save"
					 @shown="focusMyElement"
					 :title="modalForAdding ? $t('reference.create.title') : $t('reference.update-title')">
				<b-alert
					v-if="addRefError"
					:show="dismissCountDown"
					dismissible
					style="margin-bottom: 10px;"
					variant="warning"
					size="sm"
					@dismissed="dismissCountDown=0"
					@dismiss-count-down="countDownChanged"
				>
					<p v-for="(message, index) in addRefErrorMessages"
					   :key="'message'+index">
						{{ $t( message ) }}
					</p>
				</b-alert>
				<div>
					<p v-if="refInputNotFilled" style="color: red;">{{$t('please-title')}}</p>

					<b-form-group label-cols="4"
								  label-cols-lg="3"
								  label-size="sm"
								  :label="$t('reference.create.name')"
								  label-for="refName"
								  class="required"
					>
						<b-form-input :required="true" data-errormessage-value-missing="Bu maydon to'ldirilishi shart!"
									  ref="refNameRef" size="sm" v-model="item.name"
									  :placeholder="$t('reference.create.name')"/>
					</b-form-group>

					<b-form-group label-cols="4"
								  label-cols-lg="3"
								  label-size="sm"
								  :label="$t('reference.create.code')"
								  label-for="refCode"
								  class="required"
					>
						<b-form-input :required="true" data-errormessage-value-missing="Bu maydon to'ldirilishi shart!"
									   size="sm" v-model="item.code"
									  :placeholder="$t('reference.create.code')"/>
					</b-form-group>

					<b-form-group label-cols="4" label-cols-lg="3" label-size="sm"  :label="$t('reference.create.value')"
								  label-for="refValue">
						<b-form-input size="sm" v-model="item.value"
									  :placeholder="$t('reference.create.value')"/>
					</b-form-group>

					<b-form-group label-cols="4" label-cols-lg="3" label-size="sm" :label="$t('reference.create.sort')"
								  label-for="refSort">
						<b-form-input  size="sm" type="number" v-model="item.sort"
									  :placeholder="$t('reference.create.sort')"/>
					</b-form-group>

					<div class="row mt-3 createRoleModalButtons justify-content-end">
						<div class="col-4">
							<b-button variant="outline-danger" size="sm" block @click="closeUpdateRefModal">
								{{$t('actions.cancel')}}
							</b-button>
						</div>
						<div class="col-4">
							<b-button variant="outline-success" size="sm" block @click="saveRef">{{$t('actions.save')}}</b-button>
						</div>
					</div>
				</div>
			</b-modal>
			<!-- MODAL FOR ADDING OR EDITING REFERENCE -->
		</b-row>
	</div>

</template>

<script>
	import {mapGetters, mapActions, mapState} from 'vuex'

	const itemInitial = {
		id: null,
		code: '',
		name: '',
		value: '',
		sort: null
	};
	export default {
		name: 'ParentReferences',
		data: () => {
			return {
				/* DATA FOR ALERT WHEN DELETED 'NOT_ALLOWED' REFERENCE BEGIN */
				dismissCountDown: 4,
				counterForAlert: 0,
				/* DATA FOR ALERT WHEN DELETED 'NOT_ALLOWED' REFERENCE END */
				currentPage: 1,
				perPage: 20,
				editable: false,
				isBusy: false,
				focusedData: {
					id: null,
					key: null
				},
				filter:'',

				refInputNotFilled: false,
				newRef: {
					name: '',
					code: ''
				},
				fields: [
					{
						key: 'id',
						'class': 'role_id',
						sortable: true
					},
					{key: 'name'},
					{key: 'code'},
					{key: 'childRefs'},
					{
						key: 'actions',
						'class': 'table_actions'
					}
				],
				tempData: Object.assign({}, itemInitial),
				item: Object.assign({}, itemInitial),
				modalForAdding: false
			}
		},
		watch: {
			'$route.params.referenceName': {
				async handler() {
					await this.getReferencesList();
				}
			}
		},
		methods: {
			/* POPOVER METHODS BEGIN */
			onOpen(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('open')
			},
			onClose(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('close')
			},
			async onOk(itemId) {
				this.onClose(itemId)
				await this.deleteReference(itemId);
			},
			/* POPOVER METHODS END */

			countDownChanged(dismissCountDown) {
				if (dismissCountDown <= 1) {
					dismissCountDown = 3;
				}
				this.dismissCountDown = dismissCountDown
			},
			async deleteReference(id) {
				let idAndRefType = {
					id: id,
					type: 'parent'
				};
				await this.deleteRef(idAndRefType);
				await this.getReferencesList();
				if (this.notAllowedError) {
					setTimeout(() => {
						this.$store.commit('references/deleteRefError', {message: '', boolean: false})
					}, 4000)
				}
			},
			showRefModal(data) {
				this.refInputNotFilled = false;
				if (data.item) {
					this.tempData = data.item;
					this.modalForAdding = false;

					this.item.id = data.item.id;
					this.item.name = data.item.name;
					this.item.code = data.item.code;
					this.item.value = data.item.value ? data.item.value : '';
					this.item.sort = data.item.sort ? data.item.sort : null;

					this.$refs.updateRefModal.show();
				} else {
					this.item = Object.assign({}, itemInitial);
					this.tempData = Object.assign({}, itemInitial);
					this.modalForAdding = true;
					this.$refs.updateRefModal.show();
				}
			},
			focusMyElement () {
				this.$refs.refNameRef.focus();
			},
			closeUpdateRefModal() {
				this.refInputNotFilled = false;
				this.$refs.updateRefModal.hide();
			},
			async saveRef() {
				if (this.item.name.trim() != '' && this.item.code.trim() != '') {
					if (this.item.name.trim() != this.tempData.name.trim() || this.item.code.trim() != this.tempData.code.trim() ||
						(this.item.value ? this.item.value.trim() : this.item.value) != (this.tempData.value ? this.tempData.value.trim() : this.tempData.value) ||
						(this.item.sort ? this.item.sort.toString().trim() : this.item.sort) != (this.tempData.sort ? this.tempData.sort.toString().trim() : this.tempData.sort)) {

						this.refInputNotFilled = false;
						await this.updateOrCreateRefParent(this.item);
						if (this.addRefError) {
							await setTimeout(() => {
								this.$store.commit('references/addRefError', {message: '', boolean: false})
							}, 4000)
						} else {
							this.getReferencesList();
							this.refInputNotFilled = false;
							this.item = Object.assign({}, itemInitial);
							this.$refs.updateRefModal.hide();
						}

					} else {
						this.refInputNotFilled = false;
						this.$refs.updateRefModal.hide();
					}
				} else {
					this.refInputNotFilled = true;
				}
			},
			async inputUnfocused(data, newName) {
				let newRef = {...data.item};
				newRef.name = newName;
				if (data.item.name != newName) {
					await this.updateOrCreateRefParent(newRef);
					this.getReferencesList();
				}
				this.focusedData.id = null;
				this.focusedData.key = null
			},
			async childRefsLink(refName) {
				await this.$store.commit('references/resetRefChildren');
				let parentRefName = refName.toLowerCase();
				this.$router.push({ name: 'Reference:referenceName', params: { referenceName: parentRefName }})
			},
			changeFocused(data) {
				this.focusedData.id = data.item.id;
				this.focusedData.key = data.field.key;
				setTimeout(() => {
					if (data.field.key === 'name') {
						this.$refs["refNameRef"].$el.focus();
					}
				}, 50)
			},
			...mapActions('references', [
				'getReferencesList', 'updateOrCreateRefParent', 'deleteRef'
			]),
		},
		computed: {
			...mapState('references', [
				'notAllowedError', 'deleteRefErrorMessage', 'addRefError', 'addRefErrorMessages'
			]),
			...mapGetters('references', [
				'getReferences', 'getSidebarItemsWithRefs'
			]),
			computedFields() {

				return [
					{
						key: 'id',
						label: this.$t('reference.Id'),
						'class': 'role_id',
						sortable: true
					},
					{
						key: 'name',
						label: this.$t('reference.name')
					},
					{
						key: 'code',
						label: this.$t('reference.code')
					},

					{
						key: 'childRefs',
						label: this.$t('reference.child')
					},
					{
						key: 'actions',
						label: this.$t('actions.title'),
						'class': 'table_actions'
					}
				]
			}
		},
		async created() {
			this.isBusy = true;
			this.$store.commit('references/resetRefChildren');
			await this.getReferencesList();
			this.isBusy = false;
		}
	}
</script>

<style scoped>

</style>
